// extracted by mini-css-extract-plugin
export default {"player":"Player_player__X-fBF"};